import ApplicationController from 'controllers/application_controller'

export default class extends ApplicationController {

  static targets = [
    'pane',
    'tab'
  ]

  static classes = [
    'selectedPane',
    'selectedTab'
  ]

  connect () {
    console.log('segmented-navigation', {
      panes: this.paneTargets.size,
      tabs:  this.tabTargets.size,
      selectedPaneClass: this.selectedPaneClass,
      selectedTabClass:  this.selectedTabClass
    })
  }

  selectTab (event) {
    console.log('selectTab', event)
    if (event) {
      event.preventDefault()

      let selectedTab
      let tabSelector = event.params && event.params.tabSelector

      if (tabSelector) {
        selectedTab = this.tabTargets.find((tab) => tab.matches(tabSelector))
      } else {
        let element = event.currentTarget
        selectedTab = this.tabTargets.find((tab) => tab == element || tab.contains(element))
      }

      this.tabTargets.forEach((tab) => tab.classList.remove(this.selectedTabClass))
      if (selectedTab) {
        selectedTab.classList.add(this.selectedTabClass)
      }
    }
  }

  changePane (event) {
    console.log('changePane', event)
    if (event) {
      event.preventDefault()

      let paneSelector

      if (event.params && event.params.paneSelector) {
        paneSelector = event.params.paneSelector
      } else {
        let element = event.currentTarget
        let anchor  = element.querySelector('*[href]')
        if (!anchor) { anchor = element.closest('*[href]') }

        paneSelector = anchor && anchor.getAttribute('href')
      }

      this.paneTargets.forEach((pane) => pane.classList.remove(this.selectedPaneClass))

      let selectedPane = this.paneTargets.find((pane) => pane.matches(paneSelector))
      if (selectedPane) {
        selectedPane.classList.add(this.selectedPaneClass)
      }
    }
  }

  changeLanguage(event) {
    event.preventDefault()
    let tab = event.currentTarget
    let anchor = tab.querySelector('a').getAttribute('href')
    let pane = this.panesTarget.querySelector(anchor)

    this.paneTargets.forEach(pane => {
      pane.classList.remove('selected')
    })

    this.tabTargets.forEach(tab => {
      tab.classList.remove('selected')
    })

    tab.classList.add('selected')
    pane.classList.add('selected')
  }
}
